import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

export interface ContactUsResponse {
  message: string;
  success: boolean;
}

export interface ContactUsPayload {
  fromName: string;
  reason: string;
  country: string;
  subject: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class AtgContactUsService {
  constructor(private http: HttpClient, private occEndpoints: OccEndpointsService) {}

  submit(payload: ContactUsPayload): Observable<ContactUsResponse> {
    return this.http.post<ContactUsResponse>(this.occEndpoints.buildUrl('contactUs'), payload);
  }
}
